import React from "react";

export const QuoteField = React.memo(function QuoteField({
  children,
  className = "col-12 mb-2",
  error,
  id,
  label,
  required = false,
  ...inputProps
}) {
  return (
    <div className={className}>
      <div>
        <label htmlFor={id} className="w-100">
          {label}
          {required && <span className="mandatory">*</span>}
        </label>
        {children || <input id={id} className="form-control" {...inputProps} />}
        {error && <p className="form-error">{error}</p>}
      </div>
    </div>
  );
});

export const QuoteTextAreaField = React.memo(function QuoteTextAreaField({
  className = "col-12 mb-2",
  error,
  id,
  inputClassName = "",
  label,
  required = false,
  ...textareaProps
}) {
  return (
    <QuoteField className={className} error={error} id={id} label={label} required={required}>
      <textarea id={id} className={`form-control ${inputClassName}`.trim()} {...textareaProps}></textarea>
    </QuoteField>
  );
});

export const QuoteSelectField = React.memo(function QuoteSelectField({
  children,
  className = "col-12 mb-2",
  error,
  id,
  label,
  required = false,
}) {
  const control = React.isValidElement(children)
    ? React.cloneElement(children, { inputId: id })
    : children;

  return (
    <QuoteField className={className} error={error} id={id} label={label} required={required}>
      {control}
    </QuoteField>
  );
});

export const QuoteInputGroupField = React.memo(function QuoteInputGroupField({
  children,
  className = "col-12 mb-2",
  error,
  id,
  label,
  required = false,
}) {
  return (
    <QuoteField className={className} error={error} id={id} label={label} required={required}>
      <div className="input-group">{children}</div>
    </QuoteField>
  );
});
